import React from 'react';

import DateRangePicker from './DateRangePicker.jsx';

export default function FieldDateRange() {
  return <DateRangePicker field="dateRange" />;
}
